export default class UploadService {

    constructor(axios) {
        this.axios = axios;
    }

    uploadImage(fileImage, type) {
        return this.axios.post(`/upload/${type ? type : 'document'}`, fileImage).then(res => res.data);
    }
}